export default __webpack_public_path__ + "static/media/voha-1.b5d071ac.png";